import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { noop } from 'rxjs';

import { GenericModalComponent } from '../../../../../../common/components/generic-modal/generic-modal.component';
import { MODAL_XS } from '../../../../../../common/models/constants';
import { DocumentTypeRoleConfig, GenericModalData } from '../../../../../../common/models/main';
import { ApiService } from '../../../../../../common/services/api.service';
import { CacheService } from '../../../core/services/cache.service';
import { HelperService } from '../../../core/services/helper.service';
import { DocumentTypeRoleConfigModalComponent } from './config-modal/config-modal.component';

@UntilDestroy()
@Component({
  selector: 'app-document-type-role-configs',
  templateUrl: './document-type-role-configs.component.html',
  styleUrls: ['./document-type-role-configs.component.scss'],
})
export class DocumentTypeRoleConfigsComponent implements OnInit {
  dataSource: MatTableDataSource<DocumentTypeRoleConfig> = new MatTableDataSource<DocumentTypeRoleConfig>([]);
  displayedColumns = ['documentType', 'issuerTypes', 'receiverTypes', 'relatedTypes', 'actions'];
  orgId!: string;

  constructor(
    private api: ApiService,
    private cache: CacheService,
    private dialog: MatDialog,
    private helper: HelperService,
  ) {}

  ngOnInit(): void {
    this.cache.getUser().pipe(untilDestroyed(this)).subscribe(user => {
      if (!user.organization) return;
      this.orgId = user.organization.id;
      this.loadConfigs();
    });
  }

  openModal(config?: DocumentTypeRoleConfig): void {
    this.dialog.open(DocumentTypeRoleConfigModalComponent, {
      width: '560px',
      disableClose: true,
      data: { orgId: this.orgId, config },
    }).afterClosed().pipe(untilDestroyed(this)).subscribe(saved => {
      if (saved) this.loadConfigs();
    });
  }

  delete(documentType: string): void {
    const data: GenericModalData = {
      ...this.helper.translateModal({
        title: 'documentTypeRoleConfigs.deleteTitle',
        content: 'documentTypeRoleConfigs.deleteContent',
        buttons: [
          { label: 'buttons.cancel', value: false, type: 'link' },
          { label: 'buttons.delete', value: true, type: 'button' },
        ],
      }),
      hideDividers: true,
    };
    this.dialog.open(GenericModalComponent, {
      ...MODAL_XS,
      data,
      disableClose: true,
    })
      .afterClosed()
      .pipe(untilDestroyed(this))
      .subscribe(confirmed => {
        if (!confirmed) return;
        this.api.deleteDocumentTypeRoleConfig(this.orgId, documentType)
          .pipe(untilDestroyed(this))
          .subscribe({
            next: () => {
              this.api.log('toast.deleted');
              this.loadConfigs();
            },
            error: noop,
          });
      });
  }

  private loadConfigs(): void {
    this.api.getDocumentTypeRoleConfigs(this.orgId)
      .pipe(untilDestroyed(this))
      .subscribe(configs => { this.dataSource.data = configs; });
  }
}
